// extracted by mini-css-extract-plugin
export var quillEditor = "_n2-1";
export var variable = "_n2-0";